import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsEBikeRideNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        clipRule="evenodd"
        d="M34.81 27.53A9.62 9.62 0 0138 27a9.993 9.993 0 11-6.65 2.54l.96 1.85A8.023 8.023 0 1038 29a7.61 7.61 0 00-2.25.33L40.29 38h-2.26l-4.11-7.87h-.01l-2.61-4.99-6.37 12.85h-4.98A9.999 9.999 0 1110 27a9.78 9.78 0 012.78.4l1.83-3.4H4.5A4.505 4.505 0 010 19.5v-11A4.505 4.505 0 014.5 4h22.58a3.715 3.715 0 013.65-3H34v1h2v2h-2v2h2v2h-2v1h-3.27a3.715 3.715 0 01-3.65-3H4.5A2.5 2.5 0 002 8.5v11A2.5 2.5 0 004.5 22h10.68l-2.121-3.99h-2.79l-1.06-2h9l1.06 2h-3.945l2.12 3.99H29.66l-2.62-5.01h7.42a2.928 2.928 0 012.46 1.28 2.992 2.992 0 01-2.44 4.74H34v-2h.48a.981.981 0 00.995-1.067 1.036 1.036 0 00-.568-.855.976.976 0 00-.447-.098h-4.12L31.92 22h.01l.48.91-.01.02zm-24.38 8.46h7.51a8.007 8.007 0 00-2.62-4.96l.97-1.8a10.057 10.057 0 013.66 6.76h2.666l-6.048-11.38-4.908 9.1v.01zm-6.087 6.667A8 8 0 0010 45a8.015 8.015 0 007.94-7.01H9.22l-1.05-2.02 3.64-6.76A7.73 7.73 0 0010 29a8 8 0 00-5.657 13.657zM18.508 24l5.757 10.83L29.64 24z"
        fill=""
        fillRule="evenodd"
      />
    </svg>
  )
);
SvgSportsEBikeRideNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsEBikeRideNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsEBikeRideNormalLarge;
